import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const AdModeOption = props => (
    <button
        className={classNames(
            'ad-mode-option',
            R.equals(props.current, props.name) ? 'selected' : null
        )}
        key={props.name}
        onClick={() => props.onClick(props.name)}
    >
        <div>
            <i className={`fa fa-${props.name}`} aria-hidden="true" />
        </div>
        <div className="ad-mode-option-name">{props.name}</div>
    </button>
);

AdModeOption.propTypes = {
    onClick: PropTypes.func.isRequired,
    current: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
};

export default AdModeOption;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_option.js